import { Typography } from '@mui/material';
import type { TransformedSubmission } from 'api/submission';
import { BIBERK_LINKS } from 'common/constants';
import { FeedbackWrapper } from 'components/FeedbackWrapper';
import { PrimaryButton } from 'components/lib/PrimaryButton';
import type { FC } from 'react';

type BiBerkCTAProps = {
  submission: TransformedSubmission;
};

const BiBerkCTA: FC<BiBerkCTAProps> = ({ submission }) => {
  const link =
    submission?.biberk_lander === 'trucking' ? BIBERK_LINKS.trucking : BIBERK_LINKS.general;

  return (
    <FeedbackWrapper
      feedback="none"
      title="We don't have what you need right now, but our friends at biBerk can help!"
      renderAdditionalInfo={false}
      renderHomeButton={false}
    >
      <Typography
        variant="h2"
        lineHeight="140% !important"
        sx={{ color: (theme) => theme.palette.customColors.textNeutralTertiary }}
      >
        Click below to start an online quote.
      </Typography>
      <PrimaryButton text="Get biBerk Quote" href={link} sx={{ mt: 4 }} target="_blank" />
    </FeedbackWrapper>
  );
};

export default BiBerkCTA;
